// Helpers puros del canal campus. Sin estado ni efectos: fáciles de testear.

import { SARA, PRECIO_UNITARIO, COPY } from './config';

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
// Date.UTC(...).getUTCDay(): 0=domingo … 6=sábado.
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

// Nombre del día de la semana real de una fecha ISO "YYYY-MM-DD" (parseo
// manual con Date.UTC para evitar corrimientos de TZ). null si no es parseable.
function diaSemanaDe(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const [y, m, d] = iso.split('-').map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  return DIAS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
}

export const capitalizar = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Nombre del día fijo configurado por Sara, solo el nombre (para el chip del
// header), ej. "Miércoles". No confundir con fmtDiaFijo, que incluye la fecha.
export const nombreDiaFijo = (iso) => capitalizar(diaSemanaDe(iso));

// "2026-07-15" -> "miércoles 15 jul". Antes asumía "viernes" sin mirar la
// fecha real — con el día fijo configurable eso quedaba mal para cualquier
// otro día de la semana.
export function fmtDiaFijo(iso) {
  const dia = diaSemanaDe(iso);
  if (!dia) return 'el día de entrega';
  const [, m, d] = iso.split('-').map((n) => parseInt(n, 10));
  return `${dia} ${d} ${MESES[m - 1] || ''}`.trim();
}

// Formatea el ISO datetime de cierre que devuelve el API (ej.
// "2026-07-16T20:00:00-05:00") a "Jueves 8:00 pm". La parte de fecha ya viene
// en hora local de Ecuador (construida server-side con y/m/d de Ecuador), así
// que no hay ambigüedad de TZ al tomar solo lo que precede a la "T".
export function fmtCierre(isoDatetime) {
  if (!isoDatetime || typeof isoDatetime !== 'string') return null;
  const [fecha, horaParte] = isoDatetime.split('T');
  const dia = capitalizar(diaSemanaDe(fecha));
  if (!dia || !horaParte) return null;
  const hh = parseInt(horaParte.slice(0, 2), 10);
  const ampm = hh >= 12 ? 'pm' : 'am';
  const hh12 = ((hh + 11) % 12) + 1;
  return `${dia} ${hh12}:00 ${ampm}`;
}

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const metodoLabel = (metodo) => {
  if (metodo === 'transferencia') return 'transferencia';
  if (metodo === 'deuna') return 'De Una';
  return 'efectivo al retirar';
};

// Ítems del carrito (qty>0) a partir del mapa {id: qty} y el catálogo.
export const carritoItems = (cantidades, catalogo) =>
  catalogo
    .map((g) => ({ ...g, qty: cantidades[g.id] || 0 }))
    .filter((g) => g.qty > 0);

export const totalGalletas = (items) => items.reduce((s, it) => s + it.qty, 0);
export const totalUSD = (items) => totalGalletas(items) * PRECIO_UNITARIO;

// Mensaje pre-armado para WhatsApp. `numero` puede ser null (modo solo-WhatsApp
// cuando el API no respondió): en ese caso se omite la línea de #pedido. No
// incluye celular: el mensaje ya llega a Sara desde el número real de quien
// escribe, pedirlo en el formulario era redundante.
// `tipo` distingue venta del día ("dia", retiro inmediato), pre-venta del día
// fijo, y "otro día" coordinado ("coordinado", fecha/hora libres).
export function buildWaText({
  tipo = 'preventa', numero, items, nombre, metodo, viernesIso, punto, hora,
  fechaDeseada, horaDeseada,
}) {
  const lineas = [];
  lineas.push(`🍪 *${COPY.marca}*`);
  lineas.push(numero ? `Pedido #${numero}` : 'Nuevo pedido');
  lineas.push('');
  items.forEach((it) => lineas.push(`• ${it.qty}× ${it.name}`));
  const total = totalGalletas(items);
  lineas.push('');
  lineas.push(`*Total: ${total} galleta${total === 1 ? '' : 's'} — ${money(totalUSD(items))}*`);
  lineas.push(`Pago: ${metodoLabel(metodo)}`);
  lineas.push('');
  if (tipo === 'dia') {
    lineas.push(`*RETIRO HOY* · ${hora || SARA.horaEntrega}`);
  } else if (tipo === 'coordinado') {
    lineas.push(`*A COORDINAR* · piden ${fmtDiaFijo(fechaDeseada)} ${horaDeseada}`);
  } else {
    lineas.push(`Retiro: ${fmtDiaFijo(viernesIso)} · ${hora || SARA.horaEntrega}`);
  }
  lineas.push(`Punto: ${punto || SARA.puntoEntrega}`);
  lineas.push('');
  lineas.push(`Soy: ${nombre}`);
  return lineas.join('\n');
}

export const waLink = (text) =>
  `https://wa.me/${SARA.whatsapp}?text=${encodeURIComponent(text)}`;
